import React from 'react';

const Profile = () => {

    const [formData, setFormData] = React.useState({});

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value
        }));
    };


    return (
        <>
            <div className="section ">
                <div className="">
                    <div style={{
                        background: "var(--surface)",
                        border: "1px solid var(--border)",
                        borderRadius: "0px 0px 14px 14px",
                        padding: "20px 22px",
                    }}>
                        <div style={{ marginBottom: 16 }}>
                            <h3 style={{ fontFamily: "'Syne',sans-serif", fontSize: 16, fontWeight: 700, color: "var(--text)", margin: 0 }}>Profile Settings</h3>
                            <p style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 3 }}>Update your profile information</p>
                        </div>


                        <div className="oms-form-grid">

                            <div className="oms-form-group">
                                <label className="oms-form-label">First Name</label>
                                <input
                                    className="oms-form-input"
                                    placeholder="Enter first name"
                                    value={formData.firstName || ""}
                                    onChange={(e) =>
                                        handleChange("firstName", e.target.value)
                                    }
                                />
                            </div>

                            <div className="oms-form-group">
                                <label className="oms-form-label">Last Name</label>
                                <input
                                    className="oms-form-input"
                                    placeholder="Enter last name"
                                    value={formData.lastName || ""}
                                    onChange={(e) =>
                                        handleChange("lastName", e.target.value)
                                    }
                                />
                            </div>


                            <div className="oms-form-group">
                                <label className="oms-form-label">
                                    User Name{" "}
                                    <small className="text-danger">(Spaces are not allowed)</small>
                                </label>
                                <input
                                    className="oms-form-input"
                                    placeholder="Enter username (no spaces)"
                                    value={formData.companyOwner || ""}
                                    onChange={(e) =>
                                        handleChange(
                                            "companyOwner",
                                            e.target.value.replace(/\s/g, "")
                                        )
                                    }
                                />
                            </div>



                        </div>

                        <div className='mt-3 text-end '>
                            <button
                                className='oms-btn oms-btn-primary'
                                size='sm'
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Profile